import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "basic"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#basic" }),
  /*#__PURE__*/_createTextVNode(" Basic ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("code", null, ".badge"),
  /*#__PURE__*/_createTextVNode(" with "),
  /*#__PURE__*/_createVNode("code", null, ".badge-{color}"),
  /*#__PURE__*/_createTextVNode(" classes to set a badge's style defined with "),
  /*#__PURE__*/_createVNode("code", null, "$theme-colors"),
  /*#__PURE__*/_createTextVNode(" map in "),
  /*#__PURE__*/_createVNode("code", null, "src/sass/_variables.scss"),
  /*#__PURE__*/_createTextVNode(": ")
], -1)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = { class: "rounded border p-10 pb-0 d-flex flex-wrap" }
const _hoisted_6 = { class: "py-5" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`<span class="badge badge-white">New</span>
        <span class="badge badge-primary">New</span>
        <span class="badge badge-light">New</span>
        <span class="badge badge-secondary">New</span>
        <span class="badge badge-success">New</span>
        <span class="badge badge-info">New</span>
        <span class="badge badge-warning">New</span>
        <span class="badge badge-danger">New</span>
        <span class="badge badge-dark">New</span>`))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors, (item, i) => {
          return (_openBlock(), _createBlock("span", {
            key: i,
            class: [`badge-${item}`, "badge me-10 mb-10"]
          }, "New", 2))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      })
    ])
  ]))
}